var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("领导成员")]),_c('leaderCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }